import React from 'react';
import ProtocolList from './components/ProtocolList';
import './styles/ProtocolsPage.scss';

const ProtocolsPage: React.FC = () => {
  return <ProtocolList />;
};

export default ProtocolsPage;
